import { createStyles, makeStyles, Theme, borderGenerator} from 'ui-components';
import { fontText } from 'common-react';

export default makeStyles((theme: Theme) => createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 40,
    textAlign: 'right',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
  benefitsText: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'justify',
    },
    '& br': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },
  fundItemValue: {
    textAlign: 'right',
    marginTop: 8,
  },
  fundItemValueCode: {
    marginLeft: 5,
  },
  newFundChipRow: {
    marginBottom: 8,
  },
  newFundChipWrapper: {
    border: 0,
    background: theme.color.violets[50],
    font: fontText('normal', theme.fontSize.s, 12),
    borderRadius: 4,
    textAlign: 'center',
    color: theme.color.violets[50],
    textTransform: 'uppercase',
    padding: '4px 8px',
    '& .MuiChip-label': {
      background: theme.color.violets[50],
      font: fontText('normal', theme.fontSize.s, 12),
      borderRadius: 4,
      border: 0,
      margin: 0,
      textAlign: 'center',
      color: theme.color.violets[50],
      textTransform: 'uppercase',
      padding: '4px 8px',
    },
  },
  newFundInfo: {
    font: fontText('normal', theme.fontSize.s, 18),
    color: theme.color.greys[80],
    textAlign: 'center',
    background: theme.color.violets[50],
    borderLeft: borderGenerator(theme).borderMainSolid2,
    padding: 20,
    marginBottom: 18,
  },

}), { name: 'PotentialProfitSection' });
